class Notifier {
  constructor() {
    this.subscriptions = {};
  }

  on(event, callback) {
    if (!this.subscriptions[event]) {
      this.subscriptions[event] = [];
    }

    this.subscriptions[event].push(callback);
  }

  dispatch(event, data) {
    if (this.subscriptions[event]) {
      this.subscriptions[event].forEach((callback) => callback(data));
    }
  }
}

export default Notifier;
